export enum PracticePanelEnum {
  main = 1,
  about = 2,
  specialtyServices = 3,
  adminStaff = 4,
  symptoms = 5,
  conditions = 6
}
